import { GridColDef } from "@mui/x-data-grid";
import { enumToStringConverter, formatDateAndTime, moneyFormat } from "../../../helpers/appHelpers";
import { DataAction } from "../../../models/employee-allowance-history.dto";

export const EmployeeEngagementHistoryColumns: GridColDef[] = [
	{
		field: "recordedAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "jobTitle",
		headerName: "Job Title",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "contractType",
		headerName: "Contract Type",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "basicSalary",
		headerName: "Basic Salary",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.value;
			const currency = params.row.currency;
			return amount ? `${currency?.code || ""} ${moneyFormat(amount)}` : "--";
		},
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeBasicSalaryHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.value;
			const currency = params.row.previousCurrency;
			return amount ? `${currency?.code || ""} ${moneyFormat(amount)}` : "--";
		},
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.value;
			const currency = params.row.currentCurrency;
			return amount ? `${currency?.code || ""} ${moneyFormat(amount)}` : "--";
		},
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeJobTitleHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeBandHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeNotchHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value (Employee Band)",
		minWidth: 260,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.code + 
			(params.value?.employeeBand ? `(${params.value?.employeeBand?.name})` : ""),
	},
	{
		field: "currentValue",
		headerName: "Current Value (Employee Band)",
		minWidth: 260,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.code + 
			(params.value?.employeeBand ? `(${params.value?.employeeBand?.name})` : ""),
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeAllowanceHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "action",
		headerName: "Action",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div 
					className="rounded-lg px-4 py-2 min-w-[80px] text-center relative font-semibold overflow-hidden"
					style={{ color: getAllowanceActionColor(params.value) }}
				>
					<div 
						className="absolute inset-0" 
						style={{ 
							background: getAllowanceActionColor(params.value), 
							opacity: "15%"
						}}
					/>
					<p>{enumToStringConverter(params.value)}</p>
				</div>
			);
		},
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const getAllowanceActionColor = (status: DataAction) => {
	switch(status) {
		case "ADDITION":
			return "#4CAF50"
		case "REMOVAL":
			return "#F44336"
		case "UPDATE": 
			return "#2196F3"
		default: 
			return "#BF21F3"
	}
};

export const EmployeeQualificationHistoryColumns: GridColDef[] = [
	{
		field: "doneAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "previousValue",
		headerName: "Previous Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.qualification,
	},
	{
		field: "currentValue",
		headerName: "Current Value",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.qualification,
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];

export const EmployeeDisengagementHistoryColumns: GridColDef[] = [
	{
		field: "recordedAt",
		headerName: "Recorded At",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params) => formatDateAndTime(params),
	},
	{
		field: "reason",
		headerName: "Reason",
		minWidth: 400,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "jobTitle",
		headerName: "Job Title",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "contractType",
		headerName: "Contract Type",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "actor",
		headerName: "Actor",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "User",
	},
];